import CryptoJs from 'crypto-js';

var Sha256 = CryptoJs.SHA256;
var Hex = CryptoJs.enc.Hex;
var Utf8 = CryptoJs.enc.Utf8;
var AES = CryptoJs.AES;

var secret_key = process.env.REACT_APP_SECRET_KEY;
var secret_iv = process.env.REACT_APP_SECRET_IV;
var key = Sha256(secret_key).toString(Hex).substring(0, 32);
var iv = Sha256(secret_iv).toString(Hex).substring(0, 16);

export const encrypt = (data) => {
  try {
    let text;
    if (typeof data === 'object') {
      text = JSON.stringify(data);
    } else {
      text = data;
    }
    var output = AES.encrypt(text, Utf8.parse(key), {
      iv: Utf8.parse(iv),
      mode: CryptoJs.mode.CBC,
    }).toString();
    return output
  } catch (error) {
    return error;
  }
};

export const decrypt = (data) => {
  try {
    if (data !== null) {
      var decrypted = AES.decrypt(data, Utf8.parse(key), {
        iv: Utf8.parse(iv),
        mode: CryptoJs.mode.CBC,
      }).toString(Utf8);
      return JSON.parse(decrypted);
    }
  } catch (error) {
    return error;
  }
};
